/**
 * Admin Sidebar Navigation
 * Section 6.1 - Navigation menu
 */

import { NavLink } from 'react-router-dom';
import { logout } from '../utils/adminAuth';

function AdminSidebar({ onLogout }) {
  const handleLogout = () => {
    logout();
    onLogout();
  };

  const navItems = [
    { path: '/admin', label: 'Dashboard', icon: '📊', exact: true },
    { path: '/admin/vehicles', label: 'Vehicle Database', icon: '🚗' },
    { path: '/admin/pricing', label: 'Pricing Config', icon: '💰' },
    { path: '/admin/packages', label: 'Service Packages', icon: '📦' },
    { path: '/admin/errors', label: 'Error Logs', icon: '⚠️' },
    { path: '/admin/import-export', label: 'Import/Export', icon: '📁' }
  ];

  return (
    <aside className="admin-sidebar">
      <div className="sidebar-header">
        <h2>NorCal Admin</h2>
        <span className="version">v6.0</span>
      </div>

      <nav className="sidebar-nav">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.exact}
            className={({ isActive }) =>
              `nav-item ${isActive ? 'active' : ''}`
            }
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer">
        <button onClick={handleLogout} className="logout-button">
          <span className="nav-icon">🚪</span>
          <span className="nav-label">Logout</span>
        </button>
      </div>
    </aside>
  );
}

export default AdminSidebar;
